import tw from "twin.macro";

export const Wrapper = tw.section`
    flex flex-col gap-16 
`;

export const Shapes = tw.div`
   flex flex-col gap-6 
`;
